import React from 'react';

/**
 * Multi-item picker tabs — surfaced above the proof preview so customers
 * land on the right item before the proof loads.
 *
 * Hidden when the order has 1 or 0 items (the parent only mounts this
 * for multi-item orders, but we double-check defensively).
 */
export const ProofItemPicker = ({ items, activeItemId, onSelectItem }) => {
  if (!items || items.length <= 1) return null;
  return (
    <div
      className="bg-white rounded-lg shadow-lg p-4 flex items-center justify-between flex-wrap gap-3"
      data-testid="proof-item-picker"
    >
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-gray-700">Previewing:</span>
        <div className="flex flex-wrap gap-2">
          {items.map((it, idx) => {
            const label =
              it.product_type?.split(' - ').slice(-1)[0] || `Item ${idx + 1}`;
            const active = activeItemId === it.id;
            return (
              <button
                key={it.id}
                type="button"
                onClick={() => onSelectItem(it.id)}
                data-testid={`proof-item-tab-${it.id}`}
                className={`px-3 py-1 rounded-full text-xs font-semibold border transition-all ${
                  active
                    ? 'bg-[#4A7C59] text-white border-[#4A7C59]'
                    : 'bg-white text-gray-700 border-gray-300 hover:border-[#6FBF73] hover:text-[#4A7C59]'
                }`}
                title={`${it.product_type} · ${it.size || `${it.width}×${it.height}`} · qty ${it.quantity}`}
              >
                {label}
                <span className="ml-2 font-mono text-[10px] opacity-70">×{it.quantity}</span>
              </button>
            );
          })}
        </div>
      </div>
      <span className="text-xs text-gray-500">
        Each item can have its own artwork, die-line and material.
      </span>
    </div>
  );
};

export default ProofItemPicker;
